<template>
  <v-group 
    :key="`${keyPrefix}${!!keyPrefix ? '-' : ''}${config.name}-group`"
    :config="config"
    @mouseover="$emit('mouse:over', $event)"
    @mouseout="$emit('mouse:out', $event)"
    @mousedown="$emit('mouse:down', $event)"
    @touchstart="$emit('mouse:down', $event)"
    @mouseup="$emit('mouse:up', $event)"
    @touchend="$emit('mouse:up', $event)"
  >
    <slot />
  </v-group>
</template>

<script>
export default {
  name: 'Group',
  props: {
    config: {
      type: Object,
      required: true
    },
    keyPrefix: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
}
</script>